
import React, { useEffect, useState } from "react";
import "./BlogCard.css";
import { useNavigate } from "react-router-dom";

const BlogCards = () => {
  const navigate = useNavigate();
  const [blogData, setBlogData] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetch(`${BASE_URL}blogs`)
      .then((res) => res.json())
      .then((data) => {
        console.log("API RESPONSE blog:", data);

        const blogsArray = [
          ...(data?.featured || []),
          ...(data?.normal || []),
        ];

        setBlogData(blogsArray);
      })
      .catch((err) => console.error("API Error:", err));
  }, []);

  return (
    <section className="blog-section">
      <div className="blog-grid">
        {blogData.map((item, index) => (
          <div className="iso-card" key={item.id || index}>

            <div className="iso-card-image">
              <img
                src={item.image || "/default.jpg"}
                alt={item.heading}
              />
              <span className="iso-tag">Blog</span>
            </div>

            <div className="iso-card-body">
              <div className="iso-meta">
                <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <g clip-path="url(#clip0_37_1867)">
                    <path d="M4 1V3" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M8 1V3" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9.5 2H2.5C1.94772 2 1.5 2.44772 1.5 3V10C1.5 10.5523 1.94772 11 2.5 11H9.5C10.0523 11 10.5 10.5523 10.5 10V3C10.5 2.44772 10.0523 2 9.5 2Z" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M1.5 5H10.5" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_37_1867">
                      <rect width="12" height="12" fill="white" />
                    </clipPath>
                  </defs>
                </svg> {item.date}</span>
                <span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M9.5 10.5V9.5C9.5 8.96957 9.28929 8.46086 8.91421 8.08579C8.53914 7.71071 8.03043 7.5 7.5 7.5H4.5C3.96957 7.5 3.46086 7.71071 3.08579 8.08579C2.71071 8.46086 2.5 8.96957 2.5 9.5V10.5" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6 5.5C7.10457 5.5 8 4.60457 8 3.5C8 2.39543 7.10457 1.5 6 1.5C4.89543 1.5 4 2.39543 4 3.5C4 4.60457 4.89543 5.5 6 5.5Z" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round" />
                </svg> {item.author}</span>
              </div>

              <h3 className="iso-title">
                {item.heading}
              </h3>

              {/* <p className="iso-description">
                {item.short}
              </p> */}

              <p className="iso-description"
                dangerouslySetInnerHTML={{ __html: item.short }}
                ></p>

              <button
                className="iso-readmore"
                onClick={() => navigate(`/blog/${item.slug}`)}
              >
                Learn More
              </button>
            </div>

          </div>
        ))}
      </div>
    </section>
  );
};

export default BlogCards;